<template>
  <base-modal :box="box_init" :step="step">
    <z-form ref="form" @submit.native.prevent="save">
      <form-input-name v-model="form.name" :box_type="box.type" />

      <file-select-button
        :label="$t('pbx.worksheet.action.menu.input.media.label')"
        @on-browse="set_media_step"
      />
      <z-form-input :rules="{ required: true }" class="validator validator--media">
        <file-list v-model="form.params.media" />
      </z-form-input>

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.menu.input.timeout.label') }}
        </div>
        <z-form-input class="col-8">
          <timeout-select v-model="form.params.timeout" />
        </z-form-input>
      </z-form-group>

      <z-form-group class="row ivr-action-select">
        <div class="col-4 text-right">
          <span class="ivr-action-select__label ivr-action-select__label--asterisk">
            {{ $t('pbx.worksheet.action.menu.input.action.label') }}
          </span>
        </div>
        <z-form-input class="col-8">
          <action-select v-model="form.params.asterisk_sign" />
        </z-form-input>
      </z-form-group>

      <z-form-group class="row ivr-action-select">
        <div class="col-4 text-right">
          <span class="ivr-action-select__label ivr-action-select__label--sharp">
            {{ $t('pbx.worksheet.action.menu.input.action.label') }}
          </span>
        </div>
        <z-form-input class="col-8">
          <action-select v-model="form.params.sharp_sign" />
        </z-form-input>
      </z-form-group>

      <file-select-button
        :label="$t('pbx.worksheet.action.menu.input.wrong.label')"
        @on-browse="set_wrong_step"
      />
      <file-list v-model="form.params.wrong" />
    </z-form>

    <i-button
      slot="footer-ok"
      slot-scope="{ is_button_loading }"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('pbx.worksheet.modal.action.main.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import FormInputName from '../../../_base/_fragments/form-input-name';
  import FileSelectButton from '../../../_fragments/file-select-button/index';
  import ActionSelect from './action-select';
  import FileList from '../../../_fragments/file-list/index';
  import TimeoutSelect from '@autoinformer/components/worksheets/action-types/_fragments/select-timeout';
  import { StepMixin } from '../../../_base/step-mixin';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: {
      BaseModal,
      FormInputName,
      FileSelectButton,
      FileList,
      TimeoutSelect,
      ActionSelect
    },
    mixins: [StepMixin],

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      },

      set_wrong_step() {
        this.mixin_save_step(this.form);
        this.mixin_set_step('add-wrong');
      },

      set_media_step() {
        this.mixin_save_step(this.form);
        this.mixin_set_step('add-media');
      }
    }
  };
</script>

<style lang="scss">
  .ivr-action-select {
    &__label {
      display: inline-block;
      width: 100%;
      padding-right: 25px;
      background-repeat: no-repeat;
      background-position: right center;

      &--asterisk {
        background-image: url('/img/icons/pbx/ivr_asterisk_sign.svg');
      }

      &--sharp {
        background-image: url('/img/icons/pbx/ivr_sharp_sign.svg');
      }
    }
  }
</style>
